import React, { Component } from 'react';
import { ForgotPass, ResetPass } from '../../API/FetchCall';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class ForgotExcl extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            showCPassword: false,
            email_id: '',
            password: '',
            confirm_password: '',
            ref: this.props.match.params.ref,
            token: this.props.match.params.token,
            reset: false,
            title: 'Forgot'
        }
    }

    componentDidMount() {
        if (this.state.ref !== undefined) {
            this.setState({
                email_id: this.state.ref,
                reset: true,
                title: 'Reset'
            });
        }
    }
    handleShowPassword() {
        this.setState((prevState) => ({
            showPassword: !prevState.showPassword,
        }));
    }
    handleShowCPassword() {
        this.setState((prevState) => ({
            showCPassword: !prevState.showCPassword,
        }));
    }
    handleChange = (e) => {
        const propName = e.target.name;
        this.setState({ [e.target.name]: e.target.value });

    };

    onReqSubmit = (e) => {
        e.preventDefault();
        let ins = JSON.stringify({
            email: this.state.email_id,
            type: 11
        });
        ForgotPass(ins).then((res) => {
            let toastr = '';
            if (res.status === 1) {

                NotificationManager.success('Reset Link is sent to Your Mail ID, Please checck your inbox.');
             
                //this.props.history.push('/');
            } else {
                let er = res.errors[0].msg
                NotificationManager.error(er);
                 
            }

        });
    }
    onUpdateSubmit = (e) => {
        e.preventDefault();
        e.preventDefault();
        let ins = JSON.stringify({
            email: this.state.email_id,
            password: this.state.password,
            confirm_password: this.state.confirm_password,
            token: this.state.token,
        });
        ResetPass(ins).then((res) => {
            let toastr = '';
            if (res.status === 1) {
                NotificationManager.success('Reset Password Success!..you will be redirecting to login page..');

                setTimeout(function () {
                    window.location.replace('/excl_login');
                }, 500);

                //this.props.history.push('/excl_login');
            } else {
                let er = res.errors[0].msg
                NotificationManager.error(er);
               
            }

        });
    }
    render() {
        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-sm-5 login-left hidden-sm hidden-xs">
                            <h1>{this.state.title} Password ? </h1>
                            <div className="img-wrap"></div>
                        </div>
                        <div className="col-md-7 col-sm-12 login-right">
                            <div className="login-wrap">
                                <div className="nav-brand"><h1>BeWise</h1></div>
                                {this.state.reset === false ? (
                                    <form autoComplete='off' className="login-form" onSubmit={this.onReqSubmit}>
                                        <div className="form-group">
                                            <input type="email"
                                                name="email_id"
                                                className="form-control"
                                                placeholder="Email Id"
                                                required="required"
                                                onChange={this.handleChange}
                                                value={this.state.email_id}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <button type="submit" className="btn login-btn">Submit</button>
                                        </div>
                                    </form>
                                ) : (
                                    <form autoComplete='off' className="login-form" onSubmit={this.onUpdateSubmit}>
                                        <div className="form-group">
                                            <input type={this.state.showPassword ? 'text' : 'password'}
                                                name="password"
                                                className="form-control"
                                                placeholder="Password"
                                                required="required"
                                                onChange={this.handleChange}
                                                value={this.state.password}
                                            />
                                            <span
                                                toggle='#password-field'
                                                className={this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin'}
                                                onClick={() => {
                                                    this.handleShowPassword();
                                                }}
                                            ></span>
                                        </div>
                                        <div className="form-group">
                                            <input type={this.state.showCPassword ? 'text' : 'password'}
                                                name="confirm_password"
                                                className="form-control"
                                                placeholder="Confirm Password"
                                                required="required"
                                                onChange={this.handleChange}
                                                value={this.state.confirm_password}
                                            />
                                            <span
                                                toggle='#password-field'
                                                className={this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin'}
                                                onClick={() => {
                                                    this.handleShowCPassword();
                                                }}
                                            ></span>
                                        </div>
                                        <div className="form-group">
                                            <button type="submit" className="btn login-btn">Submit</button>
                                        </div>
                                    </form>
                                )}


                            </div>
                        </div>

                    </div>
                </div>
                <NotificationContainer/>         
            </React.Fragment>
        )
    }
}


export default ForgotExcl;


// WEBPACK FOOTER //
// ./src/components/Login/forget_excl.jsx